<template>
    <v-container fluid>
        <h2 class="mb-4">Hilfe</h2>
        <p>
            Bei Fragen können Sie uns unter <a href="tel:+41 44 512 13 77">+41 44 512 13 77</a> oder <a href="mailto:support@caruhome.com">support@caruhome.com</a> erreichen oder wir rufen Sie an:
        </p>
        <v-btn :loading="loading" :disabled="loading" color="secondary" class="mx-0" @click="callme">
            Rufen Sie mich an
        </v-btn>
    </v-container>
</template>

<script>
import API, { graphqlOperation } from '@aws-amplify/api'

export default {
  name: 'Help',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async callme () {
      this.loading = true
      await API.graphql(graphqlOperation('mutation{supportCall}'))
      this.$store.commit('core/snackBarShow', {text: 'Vielen Dank für Ihre Anfrage. Wir rufen Sie umgehend an.'})
      this.loading = false
    }
  }
}
</script>

<style lang="scss"></style>
